import React, { useEffect, useState, useContext } from 'react';
import { getMiniDCSessionList, getMiniTaskSessionList, LoadSession, SetCurrentSession, ResetSessions} from '../isdlData/sessionData';
import DataGrid from 'react-data-grid';
import './Components.css';
import './custom/rdgstyles.css';
// import 'react-data-grid/lib/styles.css';
import { CheckIcon, CrossIcon } from '../icons/Icons';
import { ViewOnlyContext, ThemeContext } from '../contexts/AppContext';
import { isEmailCleanable, cleanEmail, isValidTaskId } from '../utils/Utilities';
import { GetUser } from '../isdlData/matrixUserData';
import UserList from './UserList';
import TaskIdInput from './TaskIdInput';

function LoadSessions({dataCollector, onLoadSession}){

    const [miniSessionList, setMiniSessionList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedSession, setSelectedSession] = useState(null);
    const [filteredRows, setFilteredRows] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);

    const { viewOnly, setViewOnly } = useContext(ViewOnlyContext);
    const { theme, setAppTheme } = useContext(ThemeContext);
    const [currentTheme, setCurrentTheme] = useState(theme);

    const [validDC, setValidDC] = useState(false);
    const [loadedDC, setLoadedDC] = useState(null);

    const [loadedTaskId, setLoadedTaskId] = useState('');

    const [filterMode, setFilterMode] = useState("DC");

    useEffect(() => {
        if(dataCollector){
            setLoadedDC(dataCollector);
            setValidDC(true);
            setFilterMode("DC");
        }else{
            const loadDCData = async () =>{
                    const dcemail = sessionStorage.getItem('dataCollectorEmail');
            
                    if(dcemail && isEmailCleanable(dcemail)){
                        const cleanedEmail = cleanEmail(dcemail);
            
                        const userData = await GetUser(cleanedEmail.toLowerCase());
                        setLoadedDC(userData);
                        if(userData && (userData.Role === "Admin" || userData.Role === "DataCollector")){
                            setValidDC(true);
                        }else{
                            setValidDC(false);
                        }
                    }else{
                        setValidDC(false);
                    }
                }

            loadDCData();
        }
    }, []);

    useEffect(() => {
        if (loadedDC && filterMode === "DC") {
            const loadSessionList = async () => {
                // const miniSessionList = await Sessions_GetMiniDCSessionList(dataCollectorId);
                const miniSessionList = await getMiniDCSessionList(loadedDC.id);
                setMiniSessionList(miniSessionList.reverse());
                setLoading(false);
            };

            loadSessionList();
        }else if(filterMode === "TASK"){
            const loadSessionList = async () => {
                // const miniSessionList = await Sessions_GetMiniDCSessionList(dataCollectorId);
                if(loadedTaskId !== "")
                {
                    const miniSessionList = await getMiniTaskSessionList(loadedTaskId);
                    if(miniSessionList && miniSessionList.length > 0){
                        setMiniSessionList(miniSessionList.reverse());
                        setLoading(false);
                    }else if(miniSessionList.hasOwnProperty('TaskID') && miniSessionList.TaskID === loadedTaskId){
                        setMiniSessionList([miniSessionList]);
                        setLoading(false);
                    }
                }
            };

            loadSessionList();
        }

        if(loadedDC && loadedDC.Role === "Analyst"){
            setViewOnly(true);
        }else{
            setViewOnly(false);
        }

        return () => {
            setMiniSessionList([]);
            setSelectedSession(null);
        }
    }, [loadedDC, filterMode, loadedTaskId]);

    useEffect(() => {
        setCurrentTheme(theme);
        }, [theme]);

    const columns = [
        // { key: 'id', name: 'ID', width:0},
        { key: 'Date', name: 'Date', width: 170, resizable: false, minWidth: 170 },
        { key: 'UserName', name: 'Golfer', width: 100, resizable: false, minWidth: 100 },
        { key: 'Shots', name: 'Shots', width: 60, resizable: false, minWidth: 60 },
        { key: 'TaskID', name: 'TaskID', width: 150, resizable: false, minWidth: 150 },
        { key: 'Description', name: 'Description', width: 200, resizable: false, minWidth: 200},
        { key: 'ProjectID', name: 'Project', width: 100, resizable: false, minWidth: 100 },
        { key: 'TestID', name: 'Test ID', width: 100, resizable: false, minWidth: 100 },
    ];

    const consolidateSessions = (sessions) => {
        const consolidatedMap = new Map();
    
        sessions.forEach(session => {
            const { TaskID } = session;
    
            if (TaskID && TaskID.trim() !== "") { // Check if TaskID is not blank or null
                if (consolidatedMap.has(TaskID)) {
                    const existingSession = consolidatedMap.get(TaskID);
                    existingSession.Shots += GetShotCountFromSessions(session);
                    existingSession.isConsolidated = true;  // Mark as consolidated
                } else {
                    consolidatedMap.set(TaskID, {
                        ...session,
                        Shots: GetShotCountFromSessions(session),
                        isConsolidated: false
                    });
                }
            } else {
                // For sessions with blank or null TaskID, add them individually
                consolidatedMap.set(session.id, {
                    ...session,
                    Shots: GetShotCountFromSessions(session),
                    isConsolidated: false
                });
            }
        });
    
        return Array.from(consolidatedMap.values());
    };
    

    var rows = consolidateSessions(miniSessionList).map(session => ({
        ...session,
        TaskID: isValidTaskId(session.TaskID) ? session.TaskID : '',
        Date: ConvertISOToLocalTime(session.Date),
        Shots: session.Shots + (session.isConsolidated ? '*' : ''),  // Add asterisk if consolidated
    }));

    function GetBuiltSessionList(sessions){

    };

    function GetShotCountFromSessions(session){
        let count = 0;

        if(session["Setups"]){
            for(let i = 0; i < session["Setups"].length; i++){
                const setup = session["Setups"][i];
                count = count + (setup["ShotCount"] ? setup["ShotCount"] : 0);
            }
        }else if(session["Shots"]){
            count = count + session["Shots"];
            console.log('2');
        }
    
        return count;
    }

    const handleRowClick = (rowIdx) => {
        let sessRow = miniSessionList.find(s => s.id === rowIdx.row.id);
        setSelectedSession(sessRow);
    };

    const handleLoadClick = async () => {
        if (selectedSession) {
            // Handle loading the selected session
            setLoading(true);

            SetCurrentSession(null);
            ResetSessions();

            await LoadSession(selectedSession.id);

            // alert(`Loading session: ${selectedSession.Description}`);
            onLoadSession(null, "MAINWINDOW");
        }
    };

    const handleCancel = () => {
        onLoadSession(null, "START");
    }

    const handleFilterClick = () => {
        const columnFilter = document.getElementById('columnFilter').value;
        const textFilter = document.getElementById('textFilter').value.toLowerCase();
        let sortFilter = document.getElementById('sortFilter').value;

        if(columnFilter === "Date"){
            if(sortFilter === 'desc'){
                sortFilter = 'new';
            }else if(sortFilter === 'asc'){
                sortFilter = 'old';
            }
        }

        let filtered = rows.filter(row =>  {
            const cellValue = row[columnFilter] ? row[columnFilter].toString().toLowerCase() : '';
            return cellValue.includes(textFilter);
        });

        if (sortFilter === 'asc' || sortFilter === 'desc') {
            filtered.sort((a, b) => {
                const aValue = a[columnFilter].toString().toLowerCase();
                const bValue = b[columnFilter].toString().toLowerCase();
                return sortFilter === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue < bValue ? 1 : -1);
            });
        } else if (sortFilter === 'new') {
            filtered.sort((a, b) => new Date(b.Date) - new Date(a.Date));
        } else if (sortFilter === 'old') {
            filtered.sort((a, b) => new Date(a.Date) - new Date(b.Date));
        }

        setFilteredRows(filtered);
        setIsFiltered(true);
    };

    const handleFilterClearClick = () => {
        setIsFiltered(false);
    };

    function ConvertISOToLocalTime(time){
        const date = new Date(time);
    
        return date.toLocaleString().replace(',','');
    }

    const handleDCChange = (user) => {
        setLoadedDC(user);
    }

    const handleFilterRadioChange = (type) => {
        setLoading(true);
        setFilterMode(type);
    }

    const handleTaskIdInput = (value) => {
    // Make sure the UI knows we’re fetching by Task ID
    if (filterMode !== "TASK") setFilterMode("TASK");

    if (value.valid) {
        setLoading(true);           // show "Loading..." instantly
        setSelectedSession(null);   // clear any previous selection
        setLoadedTaskId(value.taskId);  // <- triggers the useEffect to fetch
    } else {
        // If it becomes invalid, clear results
        if (loadedTaskId !== "") setLoadedTaskId("");
        setMiniSessionList([]);
        setSelectedSession(null);
        setIsFiltered(false);
        setLoading(false);
    }
    };  

    const rowsToDisplay = isFiltered ? filteredRows : rows;

    return(
<div className="load-sessions-container">
    <div className='load-sessions-user-task-container' style={{flexShrink:'0'}}>
        <div className='load-sessions-user-task-item-container' style={{flexGrow:'1', marginLeft:'10px'}}>
            <input type='radio' style={{width:'20px', height:'20px', paddingLeft:'5px'}} name='filter' onClick={() => handleFilterRadioChange("DC")} checked={filterMode === "DC"}/>
            <div style={{height:'100%', marginLeft:'10px', alignContent:'center', width:'150px'}}>Data Collector</div>
            <div style={{width:'calc(100% - 50px)'}}>
                <UserList dbInitialized={true} UserChanged={handleDCChange} LoadedUser={loadedDC ? loadedDC.id : null} HasEditPermission={false} BlockSelect={filterMode !== "DC"}/>
            </div>
        </div>
        <div className='load-sessions-user-task-item-container'>
            <input type='radio' style={{width:'20px', height:'20px'}} name='filter' onClick={() => handleFilterRadioChange("TASK")} checked={filterMode === "TASK"}/>
            <div style={{height:'100%', marginRight:'10px', alignContent:'center'}}>Task ID</div>
            <TaskIdInput disabled={filterMode !== "TASK"} result={handleTaskIdInput}/>
        </div>
    </div>
    <div style={{flexShrink:'0'}}>
        <div className='exisiting-session-filter'>
            <select id="columnFilter" className='exisiting-session-filter-select'>
                <option value="Date">Date</option>
                <option value="UserName">Golfer</option>
                <option value="TaskID">Task ID</option>
                <option value="Description">Description</option>
                <option value="ProjectID">Project</option>
                <option value="TestID">Test ID</option>
            </select>
            <input type="text" id="textFilter" className="exisiting-session-filter-input"/>
            <select id="sortFilter" className='exisiting-session-filter-select'>
                <option value="asc">ASC</option>
                <option value="desc">DESC</option>
                <option value="new">Newest</option>
                <option value="old">Oldest</option>
            </select>
            <button id="filterSearchButton" className='exisiting-session-filter-button' onClick={handleFilterClick}><CheckIcon/></button>
            <button id="filterResetButton" className='exisiting-session-filter-button' onClick={handleFilterClearClick}><CrossIcon/></button>
        </div>
    </div>
    <div className="load-session-data-table" style={{flexGrow:'1'}}>
        {loading ? (
            <p>Loading...</p>
        ) : (
            <div className="dataGridContainer" style={{width:"max-content", maxWidth: "100vw", marginBottom:'0px'}}>
                <DataGrid
                className= {currentTheme == "dark" ? "rdg-dark" : "rdg-light"}
                style={{ height: "100%", contain: "none", width: "100%", margin:"0px", backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--background-secondary')}}
                columns={columns}
                rows={rowsToDisplay}
                onCellClick={handleRowClick}
                rowClass={(row) => (selectedSession?.id === row.id ? 'row-selected' : 'row-unselected')}
            />
            </div>
        )}
    </div>
    <div style={{width:'100%', marginTop:"0px", marginBottom:"20px", display:'flex', alignItems:'center', position:'relative', flexShrink:'0'}}>
        <div style={{display:'flex', alignItems:'center', flexShrink:'0'}}>
            <input id='viewOnlyCheckbox' type="checkbox" className='input'style={{marginLeft:'30px', marginRight:'10px', width:'30px', height:'30px'}} 
                checked={viewOnly} onChange={(e) => setViewOnly(e.target.checked)}/>
            <label htmlFor='viewOnlyCheckbox' style={{ textAlign: 'center', alignContent: 'center'}} >View Only</label>
        </div>
        <div style={{position:'absolute', left:'50%', transform:'translate(-50%)', display:'flex',gap:'10px'}}>
            {/* <button className="button" onClick={handleCancel}>Cancel</button> */}
            <button id="loadButton" className="button" onClick={handleLoadClick} disabled={!selectedSession}>Load</button>
        </div>
    </div>
</div>
    );
}

export default LoadSessions;